import {flipApi} from 'yxt-biz-pc/packages/api';

/**
 * 获取考勤请假审核信息
 * @param {String} formId
 * @returns
 */
export const getLeaveAuditInfo = formId => flipApi.get(`attend/audit/leave-info/${formId}`);
